import { Image as ImageIcon, Video as VideoIcon } from 'lucide-react';
import type { VideoGuidanceData } from './use-video-guidance';

// 与上传节点空状态菜单行（Connect image/video node）保持一致的样式
const MENU_ITEM_CN =
  'nodrag flex w-full items-center gap-4 px-4 py-3.5 text-sm font-medium text-foreground/80 whitespace-nowrap hover:bg-sidebar-accent/40 active:bg-sidebar-accent/60 transition-colors rounded-xl';

interface VideoGuidanceProps {
  guidance: VideoGuidanceData;
  onAddImageNode: () => void;
  onAddVideoNode: () => void;
  t: (key: string) => string;
}

export function VideoGuidance({ guidance, onAddImageNode, onAddVideoNode, t }: VideoGuidanceProps) {
  // 仅根据实际会渲染的按钮行（图片/视频）判断，prompt 建议没有按钮，不计入
  const hasRows = Boolean(guidance.imageSuggestion || guidance.videoSuggestion);

  if (!hasRows) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="flex flex-col w-fit max-w-full mx-auto">
        {guidance.imageSuggestion && (
          <button type="button" className={MENU_ITEM_CN} onClick={onAddImageNode}>
            <ImageIcon size={18} className="text-muted-foreground/70 shrink-0" />
            <span className="shrink-0">{t('Add Image Upload Node')}</span>
            {guidance.imageProgress && (
              <span className="shrink-0 text-[10px] font-bold text-primary/60 tabular-nums">
                ({guidance.imageProgress.current}/{guidance.imageProgress.max})
              </span>
            )}
          </button>
        )}
        {guidance.videoSuggestion && (
          <button type="button" className={MENU_ITEM_CN} onClick={onAddVideoNode}>
            <VideoIcon size={18} className="text-muted-foreground/70 shrink-0" />
            <span className="shrink-0">{t('Add Video Upload Node')}</span>
            {guidance.videoProgress && (
              <span className="shrink-0 text-[10px] font-bold text-primary/60 tabular-nums">
                ({guidance.videoProgress.current}/{guidance.videoProgress.max})
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

